import { create } from "zustand";
import { persist, devtools, createJSONStorage } from "zustand/middleware";
import { api, auth } from "services";

const userDetails = (set, get) => ({
  user: null,
  role: null,
  isAuthenticated: false,
  events: [],

  //method to update the global state
  write: (obj) => {
    if (typeof obj === "function") {
      const result = obj(get());
      set(result);
      return;
    }
    set((state) => ({ ...state, ...obj }));
  },

  //intially it will fetch the current user and role and all events data
  intializeState: async () => {
    try {
      const [user, role] = await Promise.all([
        auth.fetchUser(),
        api.getCurrentUserRoles(),
      ]);

      set({ user, role });
    } catch (error) {
      set({isAuthenticated:false});
      set({role:null})
      set({role:null})
      console.error("Failed to fetch the Intial Data :", error);
    }
  },
});

const userStore = create(
  devtools(
    persist(userDetails, {
      name: "user", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), //localstorage is used
      partialize: (state) => ({
        role: state.role,
        isAuthenticated: state.isAuthenticated,
      }),
    })
  )
);

export default userStore;